// Time-slot availability must follow Ukraine's wall clock (Europe/Kyiv), not the
// browser's local timezone — otherwise a customer abroad sees the wrong "now"
// and the earliest selectable arrival slot is filtered against their timezone.
//
// getKyivNow() returns a Date whose local getters (getHours, getDate, ...) read
// back the current Kyiv wall-clock values, so existing date/hour comparisons can
// stay unchanged while operating on Kyiv time.
export const getKyivNow = () => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Kyiv',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).formatToParts(new Date());

    const get = (type) => Number(parts.find((p) => p.type === type)?.value);

    return new Date(
        get('year'),
        get('month') - 1,
        get('day'),
        get('hour') % 24,
        get('minute'),
        get('second'),
    );
};
